import { defineMessages } from 'react-intl';

export const BASE_CODE_EDITOR_MESSAGES = defineMessages({
  diagnosticsSummarySingle: {
    defaultMessage: '1 {severity} on line {line}: {message}',
    id: 'EAU3RUdvyoar4XEO',
    description:
      'Screen reader announcement when there is exactly one diagnostic. {severity} is the translated severity label, {line} is the 1-based line number.',
  },
  diagnosticsSummaryMultiple: {
    defaultMessage: '{count} diagnostics: {list}',
    id: 'p7QNWYWAN7FysSqc',
    description:
      'Screen reader announcement when there are multiple diagnostics. {list} is a period-separated list of severity/line/message items.',
  },
  diagnosticsSummaryListItem: {
    defaultMessage: '{severity} on line {line}: {message}',
    id: 'ws6glsra1rg4EAIA',
    description:
      'One entry in the multiple-diagnostics list. {severity} is the translated severity label, {line} is the 1-based line number.',
  },
  diagnosticsSeverityError: {
    defaultMessage: 'error',
    id: 'RwWfbCK3X+5Ie3vr',
    description:
      'Severity label for an error diagnostic, used in screen reader announcements.',
  },
  diagnosticsSeverityWarning: {
    defaultMessage: 'warning',
    id: 'uLZU9AJNAIdoZ08c',
    description:
      'Severity label for a warning diagnostic, used in screen reader announcements.',
  },
  diagnosticsSeverityInfo: {
    defaultMessage: 'info',
    id: 'IwwqXNaWxNjk1Su9',
    description:
      'Severity label for an info diagnostic, used in screen reader announcements.',
  },
});
